var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overhide xxsensor",style:(_vm.style)},[_c('div',{ref:"sensor_con",staticClass:"dialog",domProps:{"innerHTML":_vm._s(_vm.shtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }